import styled from '@emotion/styled'
import { SvgIcon, SvgIconProps } from '@mui/material'

const StyledPath = styled.path`
  fill: ${(p) => p.theme.colors.bluishGrey};
`

const WorkOrderIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 36.664 19.999">
    <g>
      <StyledPath
        d="M32.665 13.666l-4.5-6A1.667 1.667 0 0 0 26.831 7H2.667A1.667 1.667 0 0 0 1 8.667v15h3.417a4.167 4.167 0 0 0 8.165 0h13.5a4.167 4.167 0 0 0 8.165 0h3.417v-8.334zM8.5 25.332a2.5 2.5 0 1 1 2.5-2.5 2.5 2.5 0 0 1-2.5 2.5zm21.665 0a2.5 2.5 0 1 1 2.5-2.5 2.5 2.5 0 0 1-2.5 2.5zM36 22h-1.753a4.167 4.167 0 0 0-8.165 0h-13.5a4.167 4.167 0 0 0-8.165 0h-1.75V8.667h24.165l4.5 6 .312.416.494.165L36 16.534zM25.165 10.333l3.75 5H21v-5z"
        transform="translate(-1 -7)"
      />
    </g>{" "}
  </SvgIcon>
)

export default WorkOrderIcon
